import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Bannerimage from "../../images/englishImage/gif home 1.gif";
import Bannerimage2 from "../../images/banner-bg-2.png";
import Bannerimage3 from "../../images/banner-bg-3.jpg";
import { useLanguage } from "../../Providers/LanguageContext";
import { UserContext } from "../../Providers/UserWrapper";
import phone from '../../images/produvt tour.png'
import bannerImg from '../../images/banbg.png'
import girlsiting from '../../images/bannerGirlsitting.png'
import girlstanding from '../../images/Uso Personal y Doméstico_7 INGLES.f2b0c61b8fba0fc76cec 1.png'
import personstanding from '../../images/Proveedores de Capital_1.4be5f8a46804b9729197 1.png'
import img from '../../images/1_1 USO GENERAL.088ee9996cba7290bfe8 1.png'
import Slider from "react-slick";

function Banner() {
  const { language } = useLanguage();
  const { profileData, logout } = useContext(UserContext);

  const [btnText, setBtnText] = useState();
  const navigate = useNavigate();
  function createMarkup(text) {
    return { __html: text };
  }

  useEffect(() => {
    if (profileData) {
      setBtnText(language.logout)
    } else {
      setBtnText(language.homeBannerBtn1)
    }
  }, [profileData])

  const handleBtnClick = () => {
    if (btnText === language.logout) {
      logout()
    } else {
      navigate('/login')
    }
  }

  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    // speed: 1000,
    autoplaySpeed: 3500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <>
      <div className="d-none">
        <Slider {...settings}>
          <div>
            <section
              id="banner_area"
              style={{ backgroundImage: `url('${Bannerimage}')`, backgroundSize: "contain" }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="left_cnt">
                      <div className="head">
                        <h2
                          dangerouslySetInnerHTML={createMarkup(
                            language.homeBannerHeading
                          )}
                        ></h2>
                      </div>

                      <div className="text">
                        <p>{language.homeBannerPara}</p>
                      </div>

                      <div className="bottom">

                        {/* This is Sign Up Btn */}
                        <div className="registrarse_btn">
                          <button onClick={handleBtnClick} className="btn">{profileData ? language.logout : language.homeBannerBtn1}</button>
                        </div>

                        {/* This is Download Btn */}
                        <div className="descargar_btn">
                          <a href='https://fisibilitylite.com/app_api/share_url.html' target="_blank">
                            <button className="btn">{language.homeBannerBtn2}</button>
                          </a>
                        </div>


                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-12">
                    <div className="right_cnt"></div>
                  </div>
                </div>
              </div>
            </section>
          </div>


        </Slider>
      </div>

      {/* Content -1 */}

      <div className="banner_wrapper8562" >
        <div className="banner-content-wrapper container-fluid">

          <div className="banner_content89363">
            <h1
              dangerouslySetInnerHTML={createMarkup(
                language.homeBannerHeading
              )}
            ></h1>
            <h3>{language.homeBannerPara}
            </h3>

            <div className="banner_button_wrapper865623">
              <button onClick={handleBtnClick} className="sign_button">{profileData ? language.logout : language.homeBannerBtn1}</button>

              <div className="descargar_btn856">
                <a href='https://fisibilitylite.com/app_api/share_url.html' target="_blank">
                  {/* <button className="btn">{language.homeBannerBtn2}</button> */}
                  {language.homeBannerBtn2}
                </a>
              </div>
            </div>
          </div>

          <div className="banner_img_wrapper">
            <div className="girl_img_div">
              <img src={bannerImg} />
            <div className="banner-shape1"></div>
            <div className="banner-shape2"></div>
            </div>
            {/* <div className="phone_img_div">
              <img src={phone} />
            </div>
            <div className="girl_img_div">
              <img src={girlsiting} />
            </div> */}
          </div>
        </div>
      </div>
      {/* <Slider {...settings}>


        <div className="banner_wrapper8562" >
          <div className="banner-content-wrapper container-fluid">
            <div className="banner_content89363">
              <h1
                dangerouslySetInnerHTML={createMarkup(
                  language.homeBannerHeading2
                )}
              ></h1>


              <div className="banner_button_wrapper865623">
                <button onClick={handleBtnClick} className="sign_button">{profileData ? language.logout : language.homeBannerBtn1}</button>

                <div className="descargar_btn856">
                  <a href='https://fisibilitylite.com/app_api/share_url.html' target="_blank">
                    {language.homeBannerBtn2}
                  </a>
                </div>
              </div>
            </div>

            <div className="banner_img_wrapper">
              <div className="girl_img_div">
                <img src={girlstanding} />
              </div>
              <div className="phone_img_div">
                <img src={phone} />
              </div>
              <div className="girl_img_div">
                <img src={girlsiting} />
              </div>
            </div>
          </div>
        </div>



        <div className="banner_wrapper8562" >
          <div className="banner-content-wrapper container-fluid">
            <div className="banner_content89363">
              <h1
                dangerouslySetInnerHTML={createMarkup(
                  language.homeBannerHeading3
                )}
              ></h1>

              <div className="banner_button_wrapper865623">
                <button onClick={handleBtnClick} className="sign_button">{profileData ? language.logout : language.homeBannerBtn1}</button>

                <div className="descargar_btn856">
                  <a href='https://fisibilitylite.com/app_api/share_url.html' target="_blank">
                    {language.homeBannerBtn2}
                  </a>
                </div>
              </div>
            </div>

            <div className="banner_img_wrapper">
              <div className="girl_img_div">
                <img src={personstanding} />
              </div>
              <div className="phone_img_div">
                <img src={phone} />
              </div>
              <div className="girl_img_div">
                <img src={girlsiting} />
              </div>
            </div>
          </div>
        </div>
      </Slider> */}





    </>
  );
}

export default Banner;
